import { useFormikContext } from 'formik';
import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AddArticleRequestFormArticleProviderSelectorProps } from './types';

import Select from 'components/base/Select';
import { OrderLine } from 'config/apiFunus/generated/data-contracts';
import { useArticles } from 'hooks/useArticles';
import { Provider } from 'hooks/useArticles/Provider';
import { showErrorToast } from 'utils/toasts';

export const AddArticleRequestFormArticleProviderSelector: FC<
  AddArticleRequestFormArticleProviderSelectorProps
> = ({
  disabled,
  articleCode,
  onSupplierChange,
}) => {
  const { t } = useTranslation();
  const {
    setFieldValue, values, errors, setValues,
  } = useFormikContext<OrderLine & {
        articleDescription?: string;
        supplierDescription?: string;
        idSupplier?: string;
        isCalendarOpen?: boolean;
        isProviderOpen?: boolean;
      }>();

  const {
    articleProviders,
    fetchArticleProviders,
  } = useArticles();

  useEffect(
    () => {
      if (articleCode) {
        fetchArticleProviders(articleCode)
          .catch((error) => {
            showErrorToast(error.message);
          });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [articleCode],
  );

  useEffect(() => {
    const defaultProvider = articleProviders.find((e) => e.isDefault === true);

    if (defaultProvider && values.idSupplier !== defaultProvider.code) {
      setFieldValue('idSupplier', defaultProvider.code);
    }
  }, [articleProviders, setFieldValue, values.idSupplier]);

  return ((
    <Select<Provider>
      key="supplier"
      disabled={disabled}
      error={errors.supplier}
      getLabel={({ description }) => description || ''}
      getValue={({ code }) => code || ''}
      name="supplier"
      options={articleProviders}
      placeholder={t('common.provider')}
      value={articleProviders
        .find((supplier) => supplier.code === values.idSupplier)}
      searchable
      onChange={(provider) => {
        setValues({
          ...values,
          idSupplier: provider?.code,
          supplier: provider?.email || '',
          supplierDescription: provider?.description,
        });
        onSupplierChange?.(provider?.description || '');
      }}
      onSelectClose={() => {
        setFieldValue('isProviderOpen', false);
      }}
      onSelectOpen={() => {
        setFieldValue('isProviderOpen', true);
      }}
    />
  ));
};
